import { Fragment, memo } from 'react';
import { ToastButton, ToastButtonGroup } from '@frameio/vapor';

type ToastButtonsProps = {
  buttonCallback?: (response: any) => void;
  buttonLabel?: string;
  secondaryButtonCallback?: (response: any) => void;
  secondaryButtonLabel?: string;
  response: any;
  onClose: () => void;
};

export const ToastButtons = memo(function ToastButtons({
  buttonCallback,
  buttonLabel,
  secondaryButtonCallback,
  secondaryButtonLabel,
  response,
  onClose,
}: ToastButtonsProps) {
  const ButtonParent =
    Boolean(buttonCallback) && Boolean(secondaryButtonCallback)
      ? ToastButtonGroup
      : Fragment;

  if (!buttonCallback && !secondaryButtonCallback) return null;

  return (
    <ButtonParent>
      {Boolean(buttonCallback) && buttonLabel && (
        <ToastButton
          onPress={() => {
            buttonCallback?.(response);
            onClose();
          }}
        >
          {buttonLabel}
        </ToastButton>
      )}

      {Boolean(secondaryButtonCallback) && secondaryButtonLabel && (
        <ToastButton
          onPress={() => {
            secondaryButtonCallback?.(response);
            onClose();
          }}
        >
          {secondaryButtonLabel}
        </ToastButton>
      )}
    </ButtonParent>
  );
});
